import React from "react";

const PositionTypeBox:React.FC<{ typ: 0|1}> = ( props ) => {
    const clss =  "text-center " +  (props.typ === 1 ? "text-danger" : props.typ === 0 ?  "text-success" : "text-muted");
    return (<span  className={clss}  >{props.typ === 1 ? "SHORT" : props.typ === 0 ?  "LONG" : "N/A"}</span>)
}

export default React.memo(PositionTypeBox);